var exports = {
  "$": "inlineAnnotation__40T14u",
};

module.exports = exports;
